import { UserIdSchema as a, GoalIdSchema as t } from "@hprofits/shared";
import { z as e } from "zod";
import { PaginationSchema as n, ApiSortModeSchema as r, paginatedList as m } from "../common/pagination.js";
import { idListQueryParam as i, MAX_INT4_ID as s, GoalIdParamSchema as c } from "../common/params.js";
const d = 255, o = e.string().trim().min(1, "name must be non-empty").max(d), l = e.enum(["id", "name"]), u = n.extend({
  sortBy: l.default("id"),
  sortDirection: r.default("desc"),
  search: e.string().trim().min(1).optional(),
  ownerIds: i(a).optional()
}).readonly(), h = e.object({
  id: a,
  email: e.string(),
  fullName: e.string()
}).readonly(), p = e.object({
  id: t,
  name: e.string(),
  token: e.string(),
  handler: e.string(),
  createdAt: e.string(),
  updatedAt: e.string(),
  owner: h
}).readonly(), f = m(p), A = e.object({
  name: o,
  ownerId: e.int().max(s).pipe(a).optional()
}).readonly(), I = c.extend({
  name: o
}).readonly();
export {
  A as CreateGoalSchema,
  d as GOAL_NAME_MAX_LENGTH,
  o as GoalNameSchema,
  h as GoalOwnerSchema,
  p as GoalSchema,
  u as GoalsQuerySchema,
  f as GoalsResponseSchema,
  l as GoalsSortBySchema,
  I as RenameGoalSchema
};
//# sourceMappingURL=schemas.js.map
